import React from 'react';
import { Select } from 'alurkerja-ui';
import { FormField, IFormField } from './FormField';
import { isArray } from 'lodash';

interface SelectFieldProps extends IFormField {
  options?: ISelectOption[];
  placeholder?: string;
  isSearchable?: boolean;
  isDynamicHeight?: boolean;
}

export type ISelectOption = { value: string; label: string };

export const SelectMultipleField: React.FC<SelectFieldProps> = props => {
  return (
    <FormField
      {...props}
      render={({ field }) => {
        const selected = Array.isArray(field.value)
          ? field.value.map(value => {
              const option = props?.options?.find(
                option => option.value === value,
              );
              const label = option ? option.label : value;
              return { value, label };
            })
          : [];

        const heightClassname =
          isArray(field.value) && field.value.length > 2
            ? `h-[${field.value.length * 20 + 'px'}]`
            : 'h-11';

        return (
          <Select
            classNames={{
              control: state =>
                `flex rounded-md border border-[#c4c4c480] py-2 px-3 bg-white 
              ${state.isFocused ? 'ring-indigo-600 border-indigo-600' : ''}
              ${props.isDynamicHeight ? heightClassname : 'h-11'}`,
            }}
            key={field.value}
            isMulti={true}
            defaultValue={selected}
            options={props.options}
            onChange={e => {
              field.onChange(
                (e as ISelectOption[]).map(option => option.value),
              );
            }}
            isSearchable={props.isSearchable ?? false}
            placeholder={props.placeholder}
          />
        );
      }}
    />
  );
};
